var map = {
	"./Slack_Mark_Monochrome_White.png": "7658",
	"./Slack_Mark_Web.png": "4d48",
	"./audio-bg-fill.png": "6fa7",
	"./audio-bg-fill2.png": "7c74",
	"./audio-bg-small.png": "b282",
	"./audio-bg.png": "0e10",
	"./audio-bg2.png": "dddc",
	"./audio-btn-bg.png": "7915",
	"./calendar-bg-fill.png": "ce05",
	"./chronological_preview.png": "4f84",
	"./embed-bg-fill.png": "8401",
	"./embed-black.png": "ecf9",
	"./embed-white.png": "8aac",
	"./embed.png": "229f",
	"./empty-img.png": "4183",
	"./empty-thumbnail.png": "6e1e",
	"./empty-thumbnail2.png": "4688",
	"./followup-bg-fill.png": "9242",
	"./google-icon.png": "b4a9",
	"./tape-logo-test.png": "4e5f",
	"./tape-logo-typo.png": "4f92",
	"./tape-logo-white.png": "a210",
	"./tape-logo.png": "3973",
	"./template-bug.png": "2a51",
	"./template-design.png": "d9ee",
	"./template-poll.png": "8722",
	"./template-requirement.png": "be4a",
	"./template-watch.png": "ae81",
	"./text-bg-fill.png": "d715",
	"./topic_preview.png": "ffbc",
	"./visual-comment-cursor-backup.png": "4340",
	"./visual-comment-cursor.png": "e153"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7016";